import { MdEmail } from 'react-icons/md';
import { SiUpwork } from 'react-icons/si';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { FaBehanceSquare } from 'react-icons/fa';

export default function Footer() {
  return (
    <div className="bg-whitish min-h-[300px] border-t dark:border-emerald-900 py-10 px-2 flex flex-col items-center justify-center duration-400 dark:bg-greenish drop-shadow-lg">
      <p className="sm:text-xl text-lg font-base  text-greenish underline text-center dark:text-beige ">
        This website was built using ReactJs, Tailwind CSS, and EmailJs.
      </p>
      <p className="sm:text-xl text-lg font-base text-greenish text-center dark:text-beige lg:hidden my-5">
        Let's Connect!
      </p>
      <div className="lg:hidden flex flex-row justify-center gap-x-6 md:mt-0 mt-3 items-center mx-2">
        <a
          href="https://github.com/sarahaboudalal"
          rel="noreferrer"
          target="_blank"
          className="text-sm font-medium hover:text-night text-greenish duration-300 dark:text-beige dark:hover:text-whitish"
        >
          <BsGithub className="h-8 w-6" />
        </a>
        <a
          href="https://www.linkedin.com/in/sarah-abou-dalal-977891250/"
          rel="noreferrer"
          target="_blank"
          className="text-sm font-medium hover:text-night text-greenish duration-300 dark:text-beige dark:hover:text-whitish"
        >
          <BsLinkedin className="h-8 w-6" />
        </a>
        <a
          href="https://www.upwork.com/freelancers/~01fe1bf223c6b52e3e"
          rel="noreferrer"
          target="_blank"
          className="text-sm font-medium hover:text-night text-greenish duration-300 dark:text-beige dark:hover:text-whitish"
        >
          <SiUpwork className="h-8 w-6" />
        </a>
        <a
          href="https://www.behance.net/sarahaboudalal"
          rel="noreferrer"
          target="_blank"
          className="text-sm font-medium hover:text-night text-greenish duration-300 dark:text-beige dark:hover:text-whitish"
        >
          <FaBehanceSquare className="h-8 w-6" />
        </a>
        <a
          href="mailto:sarahaboudalal@gmail.com"
          className="text-sm font-medium hover:text-night text-greenish duration-300 dark:text-beige dark:hover:text-whitish"
        >
          <MdEmail className="h-8 w-6" />
        </a>
      </div>
    </div>
  );
}
